import React from 'react'
import PropTypes from 'prop-types'
import { Provider, inject, observer } from 'mobx-react'
import Store from './stores/Store.js'
import TimeChooser from './components/TimeChooser'
// import PackageChooser from './components/PackageChooser'
// import AvailabilityResult from './components/AvailabilityResult'
// import './style.scss'


@inject("widgetStore")
@observer
export default class MiniSessionBooking extends React.Component {
  static propTypes = {
  }

  store = new Store({ widgetStore: this.props.widgetStore })

  componentDidMount() {
    const { miniSessionId } = this.props
    this.store.setup({ miniSessionId })
  }

  renderContent() {
    const { store } = this
    if(store.ready && !store.loading && store.selectedSlot) {
      return (
        <div>
          Chosen!
        </div>
      )
    }
    else if(store.ready && !store.loading)
      return (
        <TimeChooser />
      )
    else {
      return <div>Loading...</div>
    }
  }


  render() {
    const { iframe } = this.props
    const { store } = this

    return (
      <Provider store={store}>
        <div className={`wrapper ${iframe ? "within-iframe" : ""}`}>
          { this.renderContent() }
        </div>
      </Provider>
    )
  }
}
